import type { EndpointPathKey, EndpointPaths } from '@/api/console';

/**
 * EAA-1709: the paths portal-api calls when `Application.endpoint_paths` has no
 * override — mirrors `Application.ENDPOINT_DEFAULTS` server-side. Shown as each
 * input's placeholder so a blank field still says what will be called.
 */
export const ENDPOINT_PATH_DEFAULTS: Record<EndpointPathKey, string> = {
    roles: '/api/v1/roles',
    me_access: '/api/v1/me/access',
    machine_tenants: '/api/v1/management/tenants',
    machine_memberships: '/api/v1/scim/v2/Users',
    directory_users: '/api/v1/directory/users',
    organizations: '/api/v1/management/organizations',
};

/** EAA-1709: the connection-check card's keys, and the "sync from app" card's. */
export const CHECK_ENDPOINT_KEYS: EndpointPathKey[] = [
    'roles',
    'me_access',
    'machine_tenants',
    'machine_memberships',
];
export const SYNC_ENDPOINT_KEYS: EndpointPathKey[] = ['directory_users', 'organizations'];

export const ENDPOINT_PATH_KEYS = Object.keys(ENDPOINT_PATH_DEFAULTS) as EndpointPathKey[];

export type EndpointPathDraft = Record<EndpointPathKey, string>;

export function endpointDraftFrom(paths: EndpointPaths | undefined): EndpointPathDraft {
    const draft = {} as EndpointPathDraft;
    for (const key of ENDPOINT_PATH_KEYS) draft[key] = paths?.[key] ?? '';
    return draft;
}

/** Same rule as the server's `_validate_endpoint_paths`; blank means "use the default". */
export function isValidEndpointPath(value: string): boolean {
    const trimmed = value.trim();
    if (!trimmed) return true;
    return (
        trimmed.startsWith('/') &&
        !trimmed.startsWith('//') &&
        !trimmed.includes('://') &&
        !/\s/.test(trimmed) &&
        trimmed.length <= 200
    );
}

/** The PATCH body: the whole object, blank keys dropped (the server replaces it). */
export function endpointPathsPayload(draft: EndpointPathDraft): EndpointPaths {
    const payload: EndpointPaths = {};
    for (const key of ENDPOINT_PATH_KEYS) {
        const trimmed = draft[key].trim();
        if (trimmed) payload[key] = trimmed;
    }
    return payload;
}
